import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';

const AddUser = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
    });

    // const { loading } = useSelector((state) => state.users);
    const nevigate = useNavigate()

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await postRequest('/register', formData)
            if (res.status == 200) {
                toast('User added successfully!')
                nevigate('/users')
                setFormData({
                    name: '',
                    email: '',
                    mobile: '',
                    address: '',
                })
            }
        } catch (error) {
            toast(error.message || 'Failed to add user');
            console.error('There was a problem adding the user:', error.message);
        }
    };

    return (
        <>
            <div className='container-fluid mt-4'>
                <div className='mainheadig mx-4'>
                    <h4 className="text-white font-weight-bold">Add User</h4>
                </div>
                <form onSubmit={handleSubmit} className='container-fluid form-style'>
                    <div className='row'>
                        <div className='col-sm-4 mt-2'>
                            <label htmlFor='userName'>Name</label>
                            <input type='text' id='userName' placeholder='Enter users name' name='name' defaultValue={formData.name} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-4 mt-2'>
                            <label htmlFor='email'>Username</label>
                            <input type='email' defaultValue={formData.email} placeholder='Enter email/mobile' className='form-control' onChange={handleChange} name='email' id='email' />
                        </div>

                        <div className='col-sm-4 mt-2'>
                            <label htmlFor='mobile'>Password</label>
                            <input type='password' id='password' maxLength={20} placeholder='Enter Password' name='password' defaultValue={formData.mobile} className='form-control' onChange={handleChange} />
                        </div>
                    </div>
                    <div className='mt-4 text-right mx-4'>
                        <button className='btn btn-lg addbtn'>Add User</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default AddUser